import { apiFetch } from "./client.js";
export const getHabits = () => apiFetch("/habits");
export const createHabit = (body) => apiFetch("/habits", { method: "POST", body: JSON.stringify(body) });
export const renameHabit = (id, name) => apiFetch(`/habits/${id}`, { method: "PATCH", body: JSON.stringify({ name }) });
export const deleteHabit = (id) => apiFetch(`/habits/${id}`, { method: "DELETE" });
export const toggleHabit = (id) => apiFetch(`/habits/${id}/complete`, { method: "POST" });
//# sourceMappingURL=habits.js.map